var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReciept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 4C52.8954 4 52.0097 5.08541 51.0808 5.68311C50.7691 5.88366 50.3982 6 50 6C49.2429 6 48.5841 5.57933 48.2445 4.95897C47.9793 4.47452 47.5523 4 47 4C46.4477 4 46.0207 4.47452 45.7555 4.95897C45.4159 5.57933 44.7571 6 44 6C43.2429 6 42.5841 5.57933 42.2445 4.95897C41.9793 4.47452 41.5523 4 41 4C40.4477 4 40.0207 4.47452 39.7555 4.95897C39.4159 5.57933 38.7571 6 38 6C37.2429 6 36.5841 5.57933 36.2445 4.95897C35.9793 4.47452 35.5523 4 35 4C34.4477 4 34.0207 4.47452 33.7555 4.95897C33.4159 5.57933 32.7571 6 32 6C31.2429 6 30.5841 5.57933 30.2445 4.95897C29.9793 4.47452 29.5523 4 29 4C28.4477 4 28.0207 4.47452 27.7555 4.95897C27.4159 5.57933 26.7571 6 26 6C25.2429 6 24.5841 5.57933 24.2445 4.95897C23.9793 4.47452 23.5523 4 23 4C22.4477 4 22.0207 4.47452 21.7555 4.95897C21.4159 5.57933 20.7571 6 20 6C19.2429 6 18.5841 5.57933 18.2445 4.95897C17.9793 4.47452 17.5523 4 17 4C16.4477 4 16.0207 4.47452 15.7555 4.95897C15.4159 5.57933 14.7571 6 14 6C13.6018 6 13.2309 5.88366 12.9192 5.68311C11.9903 5.08541 11.1046 4 10 4C8.89543 4 8 4.89543 8 6V58C8 59.1046 8.89543 60 10 60C11.1046 60 11.9903 58.9146 12.9192 58.3169C13.2309 58.1163 13.6018 58 14 58C14.7571 58 15.4159 58.4207 15.7555 59.041C16.0207 59.5255 16.4477 60 17 60C17.5523 60 17.9793 59.5255 18.2445 59.041C18.5841 58.4207 19.2429 58 20 58C20.7571 58 21.4159 58.4207 21.7555 59.041C22.0207 59.5255 22.4477 60 23 60C23.5523 60 23.9793 59.5255 24.2445 59.041C24.5841 58.4207 25.2429 58 26 58C26.7571 58 27.4159 58.4207 27.7555 59.041C28.0207 59.5255 28.4477 60 29 60C29.5523 60 29.9793 59.5255 30.2445 59.041C30.5841 58.4207 31.2429 58 32 58C32.7571 58 33.4159 58.4207 33.7555 59.041C34.0207 59.5255 34.4477 60 35 60C35.5523 60 35.9793 59.5255 36.2445 59.041C36.5841 58.4207 37.2429 58 38 58C38.7571 58 39.4159 58.4207 39.7555 59.041C40.0207 59.5255 40.4477 60 41 60C41.5523 60 41.9793 59.5255 42.2445 59.041C42.5841 58.4207 43.2429 58 44 58C44.7571 58 45.4159 58.4207 45.7555 59.041C46.0207 59.5255 46.4477 60 47 60C47.5523 60 47.9793 59.5255 48.2445 59.041C48.5841 58.4207 49.2429 58 50 58C50.3982 58 50.7691 58.1163 51.0808 58.3169C52.0097 58.9146 52.8954 60 54 60C55.1046 60 56 59.1046 56 58V6C56 4.89543 55.1046 4 54 4Z",
    fill: "url(#paint0_linear_1_564)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44C14.8954 44 14 44.8954 14 46C14 47.1046 14.8954 48 16 48H22C23.1046 48 24 47.1046 24 46C24 44.8954 23.1046 44 22 44H16Z",
    fill: "url(#paint1_linear_1_564)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44C28.8954 44 28 44.8954 28 46C28 47.1046 28.8954 48 30 48H32C33.1046 48 34 47.1046 34 46C34 44.8954 33.1046 44 32 44H30Z",
    fill: "url(#paint2_linear_1_564)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 22C34 20.8954 34.8954 20 36 20H48C49.1046 20 50 20.8954 50 22C50 23.1046 49.1046 24 48 24H36C34.8954 24 34 23.1046 34 22Z",
    fill: "url(#paint3_linear_1_564)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30C34 28.8954 34.8954 28 36 28H48C49.1046 28 50 28.8954 50 30C50 31.1046 49.1046 32 48 32H36C34.8954 32 34 31.1046 34 30Z",
    fill: "url(#paint4_linear_1_564)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 37V15H22V37H20ZM23.4312 22.7C23.3877 22.1271 23.1838 21.6802 22.8193 21.3594C22.4604 21.0385 21.9138 20.8781 21.1795 20.8781C20.7117 20.8781 20.3283 20.9383 20.0291 21.0586C19.7354 21.1732 19.5179 21.3307 19.3765 21.5312C19.235 21.7318 19.1616 21.9609 19.1562 22.2188C19.1453 22.4307 19.1807 22.6227 19.2622 22.7945C19.3493 22.9607 19.4852 23.1125 19.6702 23.25C19.8551 23.3818 20.0917 23.5021 20.38 23.6109C20.6682 23.7198 21.0109 23.8172 21.4079 23.9031L22.7786 24.2125C23.7032 24.4187 24.4946 24.6909 25.1527 25.0289C25.8108 25.3669 26.3493 25.7651 26.7681 26.2234C27.1869 26.676 27.4942 27.1859 27.69 27.7531C27.8912 28.3203 27.9946 28.9391 28 29.6094C27.9946 30.7667 27.7199 31.7464 27.176 32.5484C26.6321 33.3505 25.8543 33.9607 24.8427 34.3789C23.8364 34.7971 22.6263 35.0062 21.2121 35.0062C19.7599 35.0062 18.4926 34.7799 17.4103 34.3273C16.3333 33.8747 15.4957 33.1786 14.8974 32.2391C14.3046 31.2937 14.0054 30.0849 14 28.6125H18.3077C18.3349 29.151 18.4627 29.6036 18.6911 29.9703C18.9196 30.337 19.2405 30.6148 19.6538 30.8039C20.0726 30.993 20.5703 31.0875 21.1469 31.0875C21.6309 31.0875 22.0361 31.0245 22.3625 30.8984C22.6888 30.7724 22.9363 30.5977 23.1049 30.3742C23.2735 30.1508 23.3605 29.8958 23.366 29.6094C23.3605 29.3401 23.2762 29.1052 23.1131 28.9047C22.9553 28.6984 22.6943 28.5151 22.3298 28.3547C21.9654 28.1885 21.4732 28.0339 20.8531 27.8906L19.1888 27.5125C17.7094 27.1745 16.5427 26.6102 15.6888 25.8195C14.8403 25.0232 14.4188 23.9375 14.4242 22.5625C14.4188 21.4453 14.7016 20.4685 15.2727 19.632C15.8493 18.7898 16.6461 18.1339 17.6632 17.6641C18.6857 17.1943 19.8578 16.9594 21.1795 16.9594C22.5284 16.9594 23.695 17.1971 24.6795 17.6727C25.6639 18.1482 26.4227 18.8185 26.9557 19.6836C27.4942 20.543 27.7661 21.5484 27.7716 22.7H23.4312Z",
    fill: "url(#paint5_linear_1_564)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_564",
    x1: 8,
    y1: 4,
    x2: 63.3412,
    y2: 51.4353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#EFF2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7C6CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_564",
    x1: 19,
    y1: 49,
    x2: 19,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155999,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796276,
    stopColor: "#B9AA99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_564",
    x1: 19,
    y1: 49,
    x2: 19,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155999,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796276,
    stopColor: "#B9AA99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_564",
    x1: 38,
    y1: 25,
    x2: 38,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155999,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796276,
    stopColor: "#B9AA99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_564",
    x1: 38,
    y1: 33,
    x2: 38,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155999,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796276,
    stopColor: "#B9AA99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_564",
    x1: 28,
    y1: 37,
    x2: 8.07059,
    y2: 24.3176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#089953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16D96F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReciept);
export default __webpack_public_path__ + "static/media/reciept.5f84a7abe4711b6e49105c5973db1e24.svg";
export { ForwardRef as ReactComponent };